<template>
    <div class="modelList_box">
        <div class="app_container">
            <div class="modelList_header"> 
                <ul class="modelList_items">
                    <li class="modelList_item ss" v-for="(item, index) in videoList" v-bind:key="item.id">
                        <div class="video_main">
                            <div class="video_top" @mouseenter="linkShow(item,index)" @mouseleave="linkHide(item,index)">
                                <img :src="'../../'+item.imgSrc" style="width:100%">
                                <span class="so-imgTag_rb">{{item.length}}</span>
				                <span class="indexAPP"><i>{{index+1}}</i></span>   
                                <div class="video_shadow"></div>
                                <div class="links text-center">
                                    <ul>
                                        <li @click="addCount(item)">
                                            <a :href="item.uku"  target="_blank" class="linkLogo" title="优酷" v-show="item.uku">
                                                <img src="../../static/img/uku.png" >
                                            </a>
                                        </li>
                                        <li @click="addCount(item)">
                                            <a :href="item.tencent"  target="_blank" class="linkLogo" title="腾讯视频" v-show="item.tencent" style="width:38px;height:38px;">
                                                <img src="../../static/img/tecent.png">
                                            </a>
                                        </li>
                                        <li @click="addCount(item)">
                                            <a :href="item.aiqiyi"  target="_blank" class="linkLogo" title="爱奇艺" v-show="item.aiqiyi" style="top:5px;">
                                                <img src="../../static/img/aiqiyi.png">
                                            </a>
                                        </li>
                                        <li @click="addCount(item)">
                                            <a :href="item.bili"  target="_blank" class="linkLogo" title="哔哩哔哩" v-show="item.bili" style="top:2px;">
                                                <img src="../../static/img/bilibili.png" >
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="video_bottom">
                                <div class="title" v-html="$options.filters.highLightMsg(item.title)" v-bind:title="item.title">{{item.title}}</div>
                                <!-- <span class="author_name" v-html="$options.filters.highLightMsg(item.title)" v-bind:title="item.title">{{item.titlee}}</span> -->
                                <div class="tags">
                                    <span class="so-icon watch-num" title="观看"><i class="icon-playtime num"></i>{{item.browse}}</span>
                                    <span class="so-icon time" title="上传时间" style="position: absolute;right: 13px;">
                                        <i class="icon-playtime time"></i>{{item.createTime.split("T")[0]}}
                                    </span>
                                </div>
                            </div>
                        </div> 
                    </li>
                </ul>
            </div>
            <div class="modelList_footer">				 
				<h4 class="text_muted">已显示全部</h4>
			</div>         
        </div>
    </div>
</template>

<script>
    import bus from '../assets/js/eventBus.js';
    export default {
        nanme:"modelList_box",
        data:function(){
            return{
                shadowShow:false,
                queryData:null,
                videoList:[],
                queryData: {
					type:"",
					keyWord: "",
					pageSize: 24,
					pageNumber: 1,
                    sort: "zonghe"
                },
                allVideosList:[],
                changeShowList_SDK:['教程/案例']
            }
            
        },
        beforeDestroy () {
            bus.$off("videosListChangeEvent");  
        },
        mounted(){  
            var _this = this;
            _this.queryVideosList(this.queryData);
            bus.$on("changeVideosList", (data) => {       
                _this.queryData = JSON.parse(JSON.stringify(data));                
                _this.queryVideosList(_this.queryData);
            });
            bus.$on("videosListChangeEvent", (data) => {  
                _this.queryVideosList(data);
            });  
            bus.$on("getchangeShowList_SDK", (data) => {
                this.changeShowList_SDK = data
            }); 
        },
        methods: {
            queryVideosList:function(data){ 
                var _this = this;
                this.$reqs.post("/videos/creSearchSqlV", data).then(function(result) {
                    _this.videoList = JSON.parse(JSON.stringify(result.data.content));                    
                    bus.$emit('changeListCount',_this.videoList.length); 
                }).catch(function(error) {
                    console.log('queryVideosList error'+error); 
                });        
            },
            linkShow:function(item,index){
                $(".modelList_item").eq(index).find(".video_shadow").show();
                $(".modelList_item").eq(index).find(".links").show();
            },
            linkHide:function(item,index){
                $(".modelList_item").eq(index).find(".video_shadow").hide();
                $(".modelList_item").eq(index).find(".links").hide();
            },
            addCount:function(item){
                var _this = this 
                // window.AnalysysAgent && window.AnalysysAgent.track('ResourcesCenter_Click', {
                //     resources: '教程/案例', // 资源
                //     type: _this.changeShowList_SDK.length == 1 ? '全部' :_this.changeShowList_SDK[1], // 类别
                //     projectName: item.title,
                //     projectID: item.id + ''
                // })
                // this.$reqs.post("/videos/addNum", item).then(function(result) {
                //     console.log("success");
                // }).catch(function(error) {
                //     console.log('addNum error'+error);
                // });
            },
        },
        filters:{
            highLightMsg:function(value){
                var _this = this;        
                if(_this.queryData && _this.queryData.keyWord){
                    var reg = new RegExp(_this.queryData.keyWord,"g");
                    if(value.indexOf(_this.queryData.keyWord) != -1){  
                        return value.replace(reg,'<div class="highlight">'+_this.queryData.keyWord+'</div>')                    
                    }else{                                        
                        return value;
                    }
                }else{
                    return value;
                }
            }
        }
    }
</script>

<style>
    @import '../assets/css/videos.css';
</style>




// WEBPACK FOOTER //
// src/components/videos.vue